import { jsx as _jsx } from "react/jsx-runtime";
/**
 * SimpleTextFilter Component
 * Single text input for simple string filters (first name, last name)
 */
import { Clear as ClearIcon } from "@mui/icons-material";
import { Box, IconButton, TextField } from "@mui/material";
export const SimpleTextFilter = ({ value, onChange, placeholder = "Enter value...", }) => {
    return (_jsx(Box, Object.assign({ sx: { pt: 2 } }, { children: _jsx(TextField, { size: "small", fullWidth: true, placeholder: placeholder, value: value, onChange: (e) => onChange(e.target.value), InputProps: {
                endAdornment: value ? (_jsx(IconButton, Object.assign({ size: "small", onClick: () => onChange(""), edge: "end" }, { children: _jsx(ClearIcon, { fontSize: "small" }) }))) : null,
            }, sx: {
                "& .MuiInputBase-input": {
                    fontSize: "13px",
                },
            } }) })));
};
export default SimpleTextFilter;
